import { useFormContext } from "react-hook-form";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { FieldProps } from ".";
import { HOTJAR_ATTRIBUTES as extraProps } from "@/core/data";
import { NumberField as ReusableNumberField } from "@flightright/reusable-components";
import { useDefaultValue } from "@/core/hooks/useDefaultValue/useDefaultValue";
import { useEffect } from "react";

const NumberField = ({ field, initialValue }: FieldProps) => {
  const { defaultValue } = field;
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const initialText = useDefaultValue(initialValue ?? defaultValue);

  useEffect(() => {
    if (initialText) {
      setValue(field.key, initialText);
    }
  }, [initialText]);
  return (
    <ReusableNumberField
      name={field.key}
      id={field.key}
      label={t(field.label)}
      control={control}
      defaultValue={initialValue}
      rules={{
        required: {
          value: field.validate?.required || false,
          message: t(`validate.${field.key}.required.message`),
        },
        pattern: {
          value: new RegExp(field.validate?.regex || ".*"),
          message: t(`validate.${field.key}.pattern.message`),
        },
        min: {
          value: Number(field.validate?.min),
          message: t(`validate.${field.key}.min.message`),
        },
        max: {
          value: Number(field.validate?.max),
          message: t(`validate.${field.key}.max.message`),
        },
      }}
      placeholder={field.properties?.placeholderText}
      disabled={field.disabled}
      error={!!errors[field.key]}
      helperText={errors[field.key]?.message?.toString()}
      {...extraProps}
    />
  );
};

export default NumberField;
